import logo from "../assets/images/logo.png"
import './header.css';

const Header = () => {
    return (
        <>
            <a className="navbar-brand zindex-6 logo-container" href="/">
                <img className="zoom-in-out" src={logo} alt="Logo"/>
            </a>
            <header className="navbar navbar-expand-lg navbar-light bg-header p-0 zindex-999">
                <div className="container-fluid">
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse text-right" id="navbarNav">
                        <ul  className="d-flex rounded-5 mx-auto fs-3 px-3 mt-3 navbaritems">
                            <li className="nav-item">
                                <a className="nav-link text-black px-3" href="/home">Home</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link text-black px-3" href="/about-us">About Us</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link text-black px-3" href="/home#our-services">Services</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link text-black px-3" href="#contact-us">Contact</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </header>
        </>
    )
}

export default Header;